// Живые счётчики в меню: критичные рейсы в «Сводке» и горящее в «Претензионной работе».
// Обновляются раз в 3 минуты, пока вкладка открыта; сбой источника — счётчик просто не показывается.
import { onBeforeUnmount, ref, watch } from 'vue'
import { fetchWorkspaceSummary } from '@/backend/workspaceApi'
import { fetchClaimsSummary } from '@/backend/claimsApi'

const REFRESH_MS = 3 * 60 * 1000

export function useMenuBadges(enabled) {
  const summary = ref(0)
  const claims = ref(0)
  let timer = null

  async function load() {
    if (!enabled.value || document.hidden) return
    const [s, c] = await Promise.allSettled([fetchWorkspaceSummary('all'), fetchClaimsSummary()])
    if (s.status === 'fulfilled') summary.value = Number(s.value?.totals?.critical) || 0
    if (c.status === 'fulfilled') {
      claims.value = (c.value?.segments || [])
        .filter((x) => x.level === 'critical')
        .reduce((sum, x) => sum + (Number(x.count) || 0), 0)
    }
  }

  function onVisible() { if (!document.hidden) load() }

  watch(enabled, (on) => {
    clearInterval(timer)
    if (!on) { summary.value = 0; claims.value = 0; return }
    load()
    timer = setInterval(load, REFRESH_MS)
  }, { immediate: true })

  document.addEventListener('visibilitychange', onVisible)
  onBeforeUnmount(() => {
    clearInterval(timer)
    document.removeEventListener('visibilitychange', onVisible)
  })

  return { summary, claims, reload: load }
}
